import type { LoadingStep } from './PluginLoadingUI';

/** Operator-facing step labels (not engineer jargon). */
export const PLUGIN_LOAD_STEP_LABELS: Record<string, string> = {
	sdk: 'Preparing shared tools',
	manifest: 'Reading app configuration',
	bundle: 'Downloading app bundle',
	routes: 'Setting up navigation',
	authorization: 'Verifying your access',
};

export function createPluginLoadingSteps(includeSdk: boolean): LoadingStep[] {
	const base: LoadingStep[] = [
		{ id: 'manifest', label: PLUGIN_LOAD_STEP_LABELS.manifest, status: 'pending' },
		{ id: 'bundle', label: PLUGIN_LOAD_STEP_LABELS.bundle, status: 'pending' },
		{ id: 'routes', label: PLUGIN_LOAD_STEP_LABELS.routes, status: 'pending' },
		{ id: 'authorization', label: PLUGIN_LOAD_STEP_LABELS.authorization, status: 'pending' },
	];

	if (!includeSdk) {
		return base;
	}

	return [
		{ id: 'sdk', label: PLUGIN_LOAD_STEP_LABELS.sdk, status: 'loading' },
		...base.map((step) => ({ ...step, status: 'pending' as const })),
	];
}

export function markStepError(steps: LoadingStep[]): LoadingStep[] {
	const currentLoading = steps.find((s) => s.status === 'loading');
	if (currentLoading) {
		return steps.map((s) =>
			s.id === currentLoading.id ? { ...s, status: 'error' } : s,
		);
	}
	const firstPending = steps.find((s) => s.status === 'pending');
	if (firstPending) {
		return steps.map((s) =>
			s.id === firstPending.id ? { ...s, status: 'error' } : s,
		);
	}
	return steps;
}
